import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import {
  FilterProps,
  PagedResponse,
} from '../../core/store/general/models/general';
import {
  IPlatform,
  OfferResponse,
  Pentest,
} from '../../core/store/pentest/models/Pentest';
import { createParams } from '../../core/store/utils/utils';

@Injectable({
  providedIn: 'root',
})
export class PentestService {
  private baseApiUrl: string = environment.API_BASE_URL;

  constructor(private readonly http: HttpClient) {}

  getPentestReports(props: FilterProps): Observable<PagedResponse<Pentest>> {
    return this.http.get<PagedResponse<Pentest>>(
      `${this.baseApiUrl}/pentest${createParams(props)}`,
    );
  }

  getPentestReportById(id: string): Observable<Pentest> {
    return this.http.get<Pentest>(`${this.baseApiUrl}/pentest/${id}`);
  }

  requestPentest(
    contactEmail: string,
    platforms: IPlatform[],
  ): Observable<boolean> {
    return this.http.post<boolean>(`${this.baseApiUrl}/pentest/request`, {
      contactEmail,
      platforms,
    });
  }

  offerResponse(
    pentestId: string,
    newBody: Partial<OfferResponse>,
  ): Observable<boolean> {
    return this.http.post<boolean>(
      `${this.baseApiUrl}/pentest/offer-response`,
      {
        pentestId,
        ...newBody,
      },
    );
  }
}
